import { useEffect, useState } from 'react';
import type { Session } from '@supabase/auth-js';
import { authClient } from '@/lib/supabase/auth';

export interface SessionState {
  readonly session: Session | null;
  /** True until the first auth event lands — distinct from "signed out". */
  readonly loading: boolean;
}

export function useSession(): SessionState {
  const [state, setState] = useState<SessionState>({ session: null, loading: true });

  useEffect(() => {
    let active = true;

    void authClient.getSession().then(({ data }) => {
      if (active) setState({ session: data.session, loading: false });
    });

    const { data: subscription } = authClient.onAuthStateChange((_event, session) => {
      if (active) setState({ session, loading: false });
    });

    return () => {
      active = false;
      subscription.subscription.unsubscribe();
    };
  }, []);

  return state;
}
